module.exports = __webpack_public_path__ + "static/media/ppt.9827f906.svg";